import React from 'react'
import { motion } from 'framer-motion'

const PartnersPage = () => (
  <div className="pt-16 lg:pt-20 min-h-screen">
    <section className="section-padding py-20">
      <div className="container-max max-w-5xl mx-auto">
        <motion.h1 className="text-4xl font-display font-bold text-white mb-10" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          Partners
        </motion.h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="glass-card p-8">
            <h2 className="text-2xl text-white font-semibold mb-2">Zippy Technologies LLC</h2>
            <p className="text-white/80">Design, platform, and AI services. Links: sales.gozippy.com • my.gozippy.com</p>
          </div>
          <div className="glass-card p-8">
            <h2 className="text-2xl text-white font-semibold mb-2">Little Eddie Audio (Edwin Perry)</h2>
            <p className="text-white/80">Performance, production, reviews, and community leadership.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
)

export default PartnersPage

